import { ENUM__component_type } from '@/enums/ENUM__component_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_hint_shortcut } from '@/hooks/hints_shortcut/use_hint_shortcut';
import { use_slice_generation, use_slice_user } from '@/hooks/store/use_slices';
import { REMOTE__generation_stop } from '@/state/generation/status/REMOTE__generation_stop';
import { REMOTE__user_settings_update } from '@/state/user/settings/REMOTE__user_settings_update';
import { ENUM__generation_status } from '@shared/dto/generation/_enums/ENUM__generation_status';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';
import { useMemo } from 'react';
import { HOOK_GENERATION__notifier } from './HOOK_GENERATION__notifier';

export function HOOK_GENERATION__stop() {
  const dispatch = use_dispatch();

  const { user_settings } = use_slice_user(['user_settings']);

  const { notifier } = HOOK_GENERATION__notifier(ENUM__component_type.PAGE_GENERATION_BUTTON_GENERATION_STOP);

  const { generation_current, generation_ids_with_locked_status } = use_slice_generation(['generation_current', 'generation_ids_with_locked_status']);

  const { on_user_uses_shortcut, on_user_uses_component } = use_hint_shortcut(EShortcutType.GENERATION_STOP);

  const can_stop_generation = useMemo(() => get_can_stop_generation(), [generation_current.status, generation_ids_with_locked_status]);

  /*
   * METHODS
   */

  async function generation_stop(is_used_shortcut: boolean) {
    if (!can_stop_generation) return;

    generation_current.assert_statuses([ENUM__generation_status.IN_PROGRESS]);

    void try_disable_autorun();

    await dispatch(REMOTE__generation_stop(generation_current._id));

    await notifier.send_action();

    is_used_shortcut ? on_user_uses_shortcut() : on_user_uses_component();
  }

  function get_can_stop_generation() {
    if (generation_current.status != ENUM__generation_status.IN_PROGRESS) return false;
    if (generation_ids_with_locked_status.has(generation_current._id)) return false;

    return true;
  }

  async function try_disable_autorun() {
    if (!user_settings.generation_autorun) return;

    let user_settings_new = user_settings.clone();
    user_settings_new.generation_autorun = false;

    await dispatch(REMOTE__user_settings_update(user_settings_new));
  }

  return { generation_stop, can_stop_generation };
}
